import React from 'react'

const DeliveryAddress = () => <div>DeliveryAddress.js</div>

export default DeliveryAddress
